import type { SCENARIO_STEP } from 'commonTypes/api/scenarios/BaseTypes';

import { sendSentryClientErrorOnce } from 'shared/lib';

interface ISendSentryFlowError {
  path: string;
  step: SCENARIO_STEP | 'empty';
  payload?: Record<string, any>;
}

/**
 * Используем полный путь до step в обьекте сценария для логирования - _.get - lodash
 * Это поможет нам быстрее локализовать проблемы у пользовтаеля
 * Пример:
 *  const path = 'footer.button.onClick.action.step';
 *  const nextStep = get(content, path);
 *  if (!nextStep) {
 *    sendSentryFlowError({ path, step, payload: { userId: user?.sub } });
 *    return;
 *   }
 */
export const sendSentryFlowError = ({ path, step, payload = {} }: ISendSentryFlowError) =>
  sendSentryClientErrorOnce(true, `${step} - missed a next step from ${path}`, payload, {
    level: 'error',
  });
